module.exports = __webpack_public_path__ + "img/go-back-arrow.a520cfa0.svg";